<template>
    <transition name="fade">
        <div data-id="lightbox" class="lightbox-wrapper d-flex justify-content-center align-items-center">
            <div class="lightbox-bg" @click="handleCloseLightbox"></div>
            <button class="lightbox-close" @click="handleCloseLightbox">
                <i class="fa fa-times fa-2x text-light" aria-hidden="true"></i>
            </button>
            <div class="d-flex justify-content-center align-items-center lightbox-inner">
                <img v-if="assetTypesMap.displayableImageTypes.includes(content.asset_type_id)" 
                    :src="content.uri_internal" 
                    class="w-100 h-100 lightbox-image"  
                    alt=""  
                />
                <video v-else-if="assetTypesMap.displayableVideoTypes.includes(content.asset_type_id)" class="w-100 h-100" controls>
                    <source v-if="content.asset_type_id === 28" :src="content.uri_internal" type="video/mp4">
                    <source v-if="content.asset_type_id === 29 && !isSafari" :src="content.uri_internal" type="video/ogg">
                    <source v-if="content.asset_type_id === 31" :src="content.uri_internal" type="video/webm">
                </video>
                <div v-else class="generic-file-wrapper d-flex flex-column align-items-center justify-content-center">
                    <div>
                        <i v-if="assetTypesMap.imagePlaceholderTypes.includes(content.asset_type_id)" 
                            class="fa fa-file-image-o fa-4x text-dark" 
                            aria-hidden="true"
                        ></i>
                        <i v-else-if="assetTypesMap.videoPlaceholderTypes.includes(content.asset_type_id)" 
                            class="fa fa-file-video-o fa-4x text-dark" 
                            aria-hidden="true"
                        ></i>
                        <i v-else class="fa fa-file-o fa-4x text-dark" aria-hidden="true"></i>
                    </div>
                    <p class="text-dark text-center mt-4 w-75">
                        <strong>
                            {{ content.asset_source }}
                        </strong>
                    </p>
                    <p>
                        {{ content.size_readable }}
                    </p>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "lightbox",
    props: {
        content: {
            required: false,
            type: [Object]
        },
        isSafari: {
            required: true,
            type: Boolean
        },
        assetTypesMap: {
            required: true,
            type: Object
        }
    },
    created() {
        const escapeHandler = e => {
            if (e.key === "Escape") {
                this.handleCloseLightbox();
            }
        };

        document.addEventListener("keydown", escapeHandler);

        this.$once("hook:destroyed", () => {
            document.removeEventListener("keydown", escapeHandler);
        });
    },
    methods: {
        handleCloseLightbox() {
            this.$emit('lightbox-closed');
        }
    }
};
</script>
<style lang="scss" scoped>
.lightbox-wrapper {
    position: fixed;
    z-index: inherit;
    z-index: 9999;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.lightbox-bg {
    background: rgb(14 14 14 / 80%);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 99991;
    cursor: pointer;
}

.lightbox-inner {
    z-index: 99992;
    position: absolute;
    width: 94%;
    height: 92%;
    margin: auto;
    background: #fff;
    border-radius: 3px;
}

.generic-file-wrapper {
    width: 18rem;
    height: 24rem;
    border-radius: 3px;
    border: 1px solid #dedede;
    word-wrap:break-word;
}

.lightbox-close {
    position: absolute;
    z-index: 99992;
    top: 0.5rem;
    right: 0.5rem;
    background: rgba(0,0,0,0);
    border: none;
    cursor: pointer;
}

.lightbox-image {
    object-fit: contain;
}
</style>
